import { render, staticRenderFns } from "./addFaceInfo.vue?vue&type=template&id=18e45d86&scoped=true&"
import script from "./addFaceInfo.vue?vue&type=script&lang=js&"
export * from "./addFaceInfo.vue?vue&type=script&lang=js&"
import style0 from "./addFaceInfo.vue?vue&type=style&index=0&id=18e45d86&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e45d86",
  null
  
)

export default component.exports